export default "__VITE_ASSET__BtVjfZJB__"